import React, { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import {
  Box,
  Typography,
  Button,
  FormControl,
  TextField,
  InputAdornment,
  IconButton,
  useTheme,
  Grid,
  useMediaQuery,
  Tabs,
  Tab,
  darken,
  Dialog,
  Select,
  MenuItem,
  InputLabel,
  Tooltip,
  Container
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FormTextField from "../form/FormTextField";
import FormFileInput from "../form/FormFileInput";
import { setAlert } from "../../features/slices/alertSlice";
import Image from "../common/Image";
import { useTranslation } from "react-i18next";
import CopiedTooltip from "../common/CopiedTooltip";
import { useNavigate, useLocation } from "react-router-dom";
import * as Constant from "../../features/constant";
import CircularProgress from '@material-ui/core/CircularProgress';
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import {
  useSaveTrackingDataMutation,
  useGetBankAccountsQuery,
  useGetDepositDescQuery
} from "../../features/api/userApiSlice";
import QrCodeIcon from '@mui/icons-material/QrCode';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import WalletIcon from '@mui/icons-material/Wallet';
import {
  useGetDepositCategoryQuery
} from "../../features/api/publicApiSlice"
import TrackFbq from "../common/TrackFbq";
import {
  useLazyGetCryptoAmountQuery
} from "../../features/api/publicApiSlice";
import AddIcon from '@mui/icons-material/Add';
import {
  useDepositMutation,
} from "../../features/api/transactionApiSlice";

const Deposit2 = (props) => {
  const location = useLocation();

  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const isLightTheme = process.env.REACT_APP_IS_LIGHT_THEME === "true";

  const [tabValue, setTabValue] = useState(0);

  const [amount, setAmount] = useState('');
  const [reamount, setReamount] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [timer, setTimer] = useState(5);
  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [isCooldown, setIsCooldown] = useState(false);
  const [gatewaySubmit, setGatewaySubmit] = useState(false);
  const [eWalletSubmit, setEWalletSubmit] = useState(false);

  const depositDetails =
    props.depositDetails || location.state?.depositDetails;

  const bankDetails = depositDetails?.banks?.filter(
    (detail) => detail?.bankCategory === 'BANK' || !detail?.bankCategory
  ) || [];

  const eWalletDetails = depositDetails?.banks?.filter(
    (detail) => detail?.bankCategory === 'EWALLET'
  ) || [];
  const [selectedBankMethod, setSelectedBankMethod] = useState("bank");
  const [selectedQrCodeMethod, setSelectedQrCodeMethod] = useState("bank");

  const [selectedQuickpayBankCategory, setSelectedQuickpayBankCategory] = useState("BANK");

  const [filteredBankDetails, setFilteredBankDetails] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [forceUpdate, setForceUpdate] = useState(0);

  const [minDeposit, setMinDeposit] = useState(0);
  const [maxDeposit, setMaxDeposit] = useState(0);

  const [open, setOpen] = useState(false);
  const isKR = process.env.REACT_APP_COUNTRY === "KR";
  const bankScrollRef = useRef(null);
  const eWalletScrollRef = useRef(null);

  const handlePreviewOpen = () => {
    setOpen(true);
  };

  const handlePreviewClose = () => {
    setOpen(false);
  };


  useEffect(() => {
    if (shouldNavigate) {
      navigate(Constant.getPath('/'));
    }
  }, [shouldNavigate, navigate]);


  const initQuickpayState = (gateways) => {
    if (!gateways) return { quickpay: null, banks: null, bank: null };
    const keys = Object.keys(gateways);
    if (keys.length === 0) return { quickpay: null, banks: null, bank: null };
    const first = gateways[keys[0]];
    return {
      quickpay: first?.paymentGateway ?? null,
      banks: first?.banks || [],
      bank: first?.banks?.[0] ?? null,
    };
  };

  const initial = initQuickpayState(depositDetails?.paymentGateways);
  const [selectedQuickpay, setSelectedQuickpay] = useState(initial.quickpay);
  const [allQuickpayBank, setAllQuickpayBank] = useState(initial.banks);
  const [selectedQuickpayBank, setSelectedQuickpayBank] = useState(initial.bank);

  const quickpayInitialized = useRef(!!depositDetails?.paymentGateways);
  useEffect(() => {
    if (!depositDetails?.paymentGateways || quickpayInitialized.current) return;
    quickpayInitialized.current = true;
    const { quickpay, banks, bank } = initQuickpayState(depositDetails.paymentGateways);
    setSelectedQuickpay(quickpay);
    setAllQuickpayBank(banks);
    setSelectedQuickpayBank(bank);
  }, [depositDetails]);

  const isGrouped = Array.isArray(allQuickpayBank) && allQuickpayBank.some(b => b?.category);
  const groupedQuickpayBank = isGrouped
    ? allQuickpayBank.reduce((acc, bank) => {
      const cat = bank.category || "BANK";
      if (!acc[cat]) acc[cat] = [];
      acc[cat].push(bank);
      return acc;
    }, {})
    : null;

  const { t } = useTranslation();
  const { data: depositCategory = [] } = useGetDepositCategoryQuery();
  const categorySortOrder = depositCategory?.result || { bank: 1, ewallet: 2, paymentgateway: 3 };

  const depositType = [];
  if (bankDetails && Object.keys(bankDetails).length > 0) {
    depositType.push({ label: t("walletcard.depositpage.title"), category: "bank" });
  }

  if (eWalletDetails && Object.keys(eWalletDetails).length > 0) {
    depositType.push({ label: t("walletcard.depositpage.ewallet"), category: "ewallet" });
  }

  if (depositDetails?.paymentGateways && Object.keys(depositDetails.paymentGateways).length > 0) {
    depositType.push({ label: t("walletcard.depositpage.quickpay.title"), category: "paymentgateway" });
  }

  // Keeps the translated "Min …" wording but swaps in the real enforced minimum.
  const withLiveMin = (key) => {
    const formatted = Number(minDeposit || 0).toFixed(2);
    const base = t(key);
    if (!base || base === key) return `Min ${formatted}`;      // key missing / unresolved
    return /\d/.test(base)
      ? base.replace(/[\d.,]+/, formatted)                     // replace first numeric run
      : `${base} ${formatted}`;                                // string had no number
  };

  const depositSchema = yup.object().shape({
    amount: yup
      .number()
      .typeError(t("validation.amountonly"))
      .min(minDeposit, withLiveMin("validation.minamount"))
      .max(maxDeposit, t("validation.maxamount"))
      .required(t("validation.amountisrequired")),
    receipt: yup.mixed().test("file", t("validation.receipt"), (value) => {
      if (value?.length > 0) {
        return true;
      }
      return false;
    }).test("fileSize", t("validation.filesize"), (value) => {
      // Check if the file size exceeds 1MB
      if (value?.length > 0) {
        const file = value[0];
        return file.size <= 5 * 1024 * 1024;
      }
      return true;
    }),
    // ignore for now
    // promotion: yup.string().required("Please select a promotion."),
  });

  const quickpaySchema = yup.object().shape({
    amount: yup
      .number()
      .typeError(t("validation.amountonly"))
      .min(minDeposit, withLiveMin("validation.minamount"))
      .max(maxDeposit, t("validation.maxamount"))
      .required(t("validation.amountisrequired")),
  });

  const { control, handleSubmit, setValue, reset } = useForm({
    resolver: yupResolver(depositSchema),
  });

  const getAvailableMethods = (bank) => {
    const type = bank?.type?.toLowerCase() || "bank";
    if (type === "qrcode") return ["qrCode"];
    if (type === "bank") return ["bank"];
    if (type === "bank&qrcode") return ["bank", "qrCode"];
    if (type === "qrcode&bank") return ["qrCode", "bank"];
    return ["bank"];
  };

  const bankMethodOptions = Array.from(
    new Set(bankDetails.flatMap((bank) => getAvailableMethods(bank)))
  );

  const {
    control: qpControl,
    handleSubmit: handleQpSubmit,
    setValue: setQpValue,
    reset: resetQp,
  } = useForm({
    resolver: yupResolver(quickpaySchema),
  });

  const sortedDepositType =
    depositCategory?.result && Object.keys(depositCategory.result).length > 0
      ? depositType.slice().sort(
        (a, b) => (categorySortOrder[a.category] ?? 99) - (categorySortOrder[b.category] ?? 99)
      )
      : [];

  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    if (!selectedCategory && sortedDepositType.length > 0) {
      setSelectedCategory(sortedDepositType[0].category);
    }
  }, [sortedDepositType, selectedCategory]);

  const [selectedBank, setSelectedBank] = useState();
  const [selectedEwalletBank, setSelectedEwalletBank] = useState();

  useEffect(() => {
    if (bankDetails.length === 1) {
      setSelectedBank(bankDetails[0]);
    }
  }, [])

  useEffect(() => {
    if (eWalletDetails.length === 1) {
      setSelectedEwalletBank(eWalletDetails[0]);
    }
  }, [])

  useEffect(() => {
    if (allQuickpayBank && Array.isArray(allQuickpayBank) && allQuickpayBank.some(b => b?.category)) {
      const firstCategory = [...new Set(allQuickpayBank.map(b => b.category))][0];
      setSelectedQuickpayBankCategory(firstCategory || "BANK");
    }
  }, [allQuickpayBank]);

  useEffect(() => {
    if (!bankScrollRef.current || selectedBank === null) return;

    bankScrollRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [selectedBank]);

  useEffect(() => {
    if (!eWalletScrollRef.current) return;

    eWalletScrollRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [selectedEwalletBank]);


  useEffect(() => {
    const methods = getAvailableMethods(selectedBank);
    setSelectedBankMethod(methods[0]);
  }, [selectedBank]);

  useEffect(() => {
    const methods = getAvailableMethods(selectedEwalletBank);
    console.log(methods);
    setSelectedQrCodeMethod(methods[0]);
  }, [selectedEwalletBank]);

  useEffect(() => {
    let selectedMinAmount = selectedCategory === 'bank'
      ? selectedBank?.minAmount
      : selectedCategory === 'paymentgateway'
        ? selectedQuickpayBank?.minAmount
        : selectedCategory === 'ewallet'
          ? selectedEwalletBank?.minAmount
          : undefined;

    let finalMinDeposit;

    const specificMin = selectedMinAmount;
    const globalMin = depositDetails?.minDeposit;

    if (specificMin != null) {
      finalMinDeposit = (globalMin != null) ? Math.max(specificMin, globalMin) : specificMin;
    }
    else {
      finalMinDeposit = globalMin ?? 0;
    }
    setMinDeposit(finalMinDeposit);

    let selectedMaxAmount = selectedCategory === 'bank'
      ? selectedBank?.maxAmount
      : selectedCategory === 'paymentgateway'
        ? selectedQuickpayBank?.maxAmount
        : selectedCategory === 'ewallet'
          ? selectedEwalletBank?.maxAmount
          : undefined;

    let finalMaxDeposit;

    const specificMax = selectedMaxAmount;
    const globalMax = depositDetails?.maxDeposit;

    if (specificMax != null) {
      finalMaxDeposit = (globalMax != null) ? Math.min(specificMax, globalMax) : specificMax;
    }
    else {
      finalMaxDeposit = globalMax ?? 0;
    }

    setMaxDeposit(finalMaxDeposit);

  }, [selectedCategory, selectedBank, selectedQuickpayBank, selectedEwalletBank, depositDetails]);

  const [deposit, { data, isLoading, isError, isSuccess, error }] =
    useDepositMutation();

  const [saveTrackingData] = useSaveTrackingDataMutation();

  const handleTabChange = (event, newValue) => {
    const selectedCategory = sortedDepositType[newValue]?.category;
    setTabValue(newValue);
    setSelectedCategory(selectedCategory);
    setReamount(0);
  };

  const submitTrackingData = async () => {
    try {
      const fbc = Cookies.get("_fbc");
      const fbp = Cookies.get("_fbp");
      const ttclid = Cookies.get("ttclid");

      const payload = {
        fbc: fbc,
        fbp: fbp,
        ttclId: ttclid
      };
      await saveTrackingData(payload);
    } catch (error) {
      // Handle errors
    }
  }

  const submitDeposit = async (data) => {
    const formData = new FormData();
    //const date = new Date(data.date).toISOString().split("T");
    formData.append("amount", data.amount);
    //formData.append("receiptDateTime", date[0] + ";" + date[1]);
    formData.append("receipt", data.receipt[0]);
    if (selectedCategory === 'bank') {
      formData.append(
        "bankCode",
        selectedBank?.bankCode || bankDetails[0].bankCode
      );
      formData.append("depositMethod", selectedBankMethod);
    }
    else if (selectedCategory === 'ewallet') {
      formData.append(
        "bankCode",
        selectedEwalletBank?.bankCode || selectedEwalletBank[0].bankCode
      );
      formData.append("depositMethod", selectedQrCodeMethod);
    }

    setEWalletSubmit(true);

    if (data.amount > 1000) {
      TrackFbq('trackCustom', 'submitDeposit_' + data.amount);
    }

    await submitTrackingData();
    await deposit({ deposit: formData, paymentGateway: "" }).unwrap().then(() => {
      setEWalletSubmit(false);

      let timerInterval;
      Swal.fire({
        title: t("walletcard.depositpage.deposittitle"),
        html: t("walletcard.depositpage.depositmessage"),
        timer: 3000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
          const timer = Swal.getPopup().querySelector("b");
          timerInterval = setInterval(() => {
            timer.textContent = `${Swal.getTimerLeft()}`;
          }, 100);
        },
        willClose: () => {
          clearInterval(timerInterval);
        }
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          setShouldNavigate(true);
          //console.log("I was closed by the timer");
        }

        const cooldownDuration = process.env.REACT_APP_DEPOSIT_TIMER ? Number(process.env.REACT_APP_DEPOSIT_TIMER) : 15;
        const endTime = Date.now() + cooldownDuration * 1000;


        sessionStorage.setItem(
          "cooldownTimer",
          JSON.stringify({ endTime, isCooldown: true })
        );

        setTimer(cooldownDuration);
        setIsCooldown(true);
      });
    }).catch((error) => {
      setEWalletSubmit(false);

      Swal.fire({
        icon: 'error',
        title: error?.data?.message || error?.message || "Something went wrong",
        confirmButtonText: "OK"
      });
    });

  };

  useEffect(() => {
    if (selectedBankMethod === 'qrCode') {
      const filtered = bankDetails.filter(
        bank => !!bank.qrCodeUrl
      );

      setFilteredBankDetails(filtered);
    } else if (selectedBankMethod === 'bank') {
      const filtered = bankDetails

      setFilteredBankDetails(filtered);
    }
  }, [selectedBankMethod])


  const submitQuickpay = async (data) => {
    const formData = new FormData();
    // formData.append("bankCode", selectedQuickpayBank?.bankCode);
    if (isKR && selectedQuickpay === 'SULIFU') {
      if (!selectedUserBank) {
        dispatch(
          setAlert({
            isOpen: true,
            message: t("validation.pleaseselectbank"),
            variant: "error",
          })
        );
        return;
      }
      formData.append("bankCode", selectedUserBank.bankCode);
      formData.append("bankAccountNumber", selectedUserBank.bankAccountNumber);
    } else {
      formData.append("bankCode", selectedQuickpayBank?.bankCode);
    }
    formData.append("amount", data?.amount);

    setGatewaySubmit(true);

    Swal.fire({
      title: t("walletcard.depositpage.gatewaytitle"),
      html: t("walletcard.depositpage.gatewaymessage"),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (data?.amount > 1000) {
      TrackFbq('trackCustom', 'submitDeposit_' + data?.amount);
    }

    await submitTrackingData();
    const res = await deposit({
      deposit: formData,
      paymentGateway: selectedQuickpay,
    })

    if (res) {
      Swal.close();
      setGatewaySubmit(false);

      if (res.data.result.paymentUrl && res.data.result.success === true) {
        navigate(Constant.getPath('/'));
        if (selectedQuickpay === "LNWPAY" || selectedQuickpay === "LNWESEWA" || selectedQuickpay === "LNWPAYHK") {
          setTimeout(() => {
            window.location.href = Constant.getPath("/paymentGatewayLauncher") + "?url=" + res.data.result.paymentUrl;
          }, 500);
        } else {
          setTimeout(() => {
            window.location.href = res.data.result.paymentUrl
          }, 500);
        }
      } else {
        dispatch(
          setAlert({
            isOpen: true,
            message: t("walletcard.depositpage.paymentgatewayError"),
            variant: "error",
          })
        );
      }
    }
    else {
      Swal.close();
      setGatewaySubmit(false);
    }
    resetQp();
    // if (!isDisabled) {
    //   setTimer(5);
    //   setIsDisabled(true);
    // }
    // navigate(Constant.getPath('/'));
  };

  useEffect(() => {

    if (amount !== "") {
      const processingFee =
        selectedCategory === 'bank'
          ? selectedBank?.processingFee ?? 0
          : selectedCategory === 'paymentgateway'
            ? selectedQuickpayBank?.processingFee ?? 0
            : selectedCategory === 'ewallet'
              ? selectedEwalletBank?.processingFee ?? 0
              : undefined;
      const reamountValue = parseFloat(amount || 0) + parseFloat(processingFee);

      const effectiveMaxDeposit = maxDeposit;

      if (parseFloat(amount) > effectiveMaxDeposit) {
        setErrorMessage(t("validation.maxamount", { max: effectiveMaxDeposit }));
      } else {
        setErrorMessage("");
      }


      setReamount(isNaN(reamountValue) ? "" : reamountValue.toFixed(2));
      setForceUpdate((prev) => prev + 1);
    }
  }, [amount, depositDetails]);


  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  useEffect(() => {
    if (isCooldown && timer > 0) {
      const intervalId = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer - 1 <= 0) {
            clearInterval(intervalId);
            setIsCooldown(false);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [isCooldown, timer]);

  useEffect(() => {
    const savedTimerData = sessionStorage.getItem("cooldownTimer");
    if (savedTimerData) {
      const { endTime, isCooldown } = JSON.parse(savedTimerData);
      const now = Date.now();
      const timeLeft = Math.round((endTime - now) / 1000);

      if (isCooldown && timeLeft > 0) {
        setTimer(timeLeft);
        setIsCooldown(true);
      } else {
        sessionStorage.removeItem("cooldownTimer");
      }
    }
  }, []);

  const handleSubmitClick = () => {
    setTimer(process.env.REACT_APP_DEPOSIT_TIMER ? Number(process.env.REACT_APP_DEPOSIT_TIMER) : 15);
    setIsDisabled(true);
  };

  useEffect(() => {
    if (!isLoading && isSuccess) {
      if (selectedCategory !== "paymentgateway") {
        dispatch(
          setAlert({
            isOpen: true,
            message: t("walletcard.depositpage.successmessage"),
            variant: "success",
          })
        );
      }

      reset();
      TrackFbq('trackCustom', 'CompleteDeposit');
    }
    if (!isLoading && isError) {
      dispatch(
        setAlert({
          isOpen: true,
          message: error?.data?.message,
          variant: "error",
        })
      );
      reset();
    }
  }, [isLoading, isSuccess, isError]);

  const [cryptoAmount, setCryptoAmount] = useState('');
  const [triggerGetCryptoAmount, { cryptoAmountData, cryptoAmountLoading, cryptoAmountError }] = useLazyGetCryptoAmountQuery();

  const getCryptoAmount = async (amount, bankCode, paymentGateway) => {
    const data = await triggerGetCryptoAmount({
      bankCode,
      amount,
      paymentGateway,
    }).unwrap();

    return data.result;
  };

  useEffect(() => {
    const fetchCryptoAmount = async () => {
      if (
        selectedCategory === 'paymentgateway' &&
        selectedQuickpayBank &&
        selectedQuickpay &&
        amount &&
        depositDetails?.paymentGateways[selectedQuickpay]?.isCrypto
      ) {
        const result = await getCryptoAmount(amount, selectedQuickpayBank.bankCode, selectedQuickpay);
        setCryptoAmount(result);
      } else {
        setCryptoAmount('');
      }
    };
    fetchCryptoAmount();
  }, [selectedCategory, selectedQuickpayBank, selectedQuickpay, amount, depositDetails]);

  const {
    data: userBankAccounts,
    isLoading: isUserBankAccountsLoading,
  } = useGetBankAccountsQuery(undefined, {
    skip: !isKR || selectedCategory !== 'paymentgateway', // Only fetch if KR and paymentgateway tab is selected
  });

  const {
    data: depositDesc,
    isLoading: isDepositDescLoading,
    isError: isDepositDescError,
    isSuccess: isDepositDescSuccess,
    error: depositDescError,
  } = useGetDepositDescQuery();

  useEffect(() => {
    if (filteredBankDetails?.length > 0 && !selectedBank) {
      setSelectedBank(filteredBankDetails[0]);
    }
  }, [filteredBankDetails])

  const [selectedUserBankId, setSelectedUserBankId] = useState("");

  const selectedUserBank = userBankAccounts?.result?.data?.find(
    (b) => `${b.bankCode}-${b.bankAccountNumber}` === selectedUserBankId
  );
  const bankConfigMap = userBankAccounts?.result?.bankConfigs?.reduce((acc, cfg) => {
    acc[cfg.bankCode] = cfg.bankName;
    return acc;
  }, {});
  useEffect(() => {
    // Pre-select the first bank account for KR users
    if (isKR && userBankAccounts?.result?.data?.length > 0 && !selectedUserBankId) {
      const firstBank = userBankAccounts.result.data[0];
      setSelectedUserBankId(`${firstBank.bankCode}-${firstBank.bankAccountNumber}`);
    }
  }, [isKR, userBankAccounts, selectedUserBankId]);
  return (
    <Container sx={{
      py: { xs: 10, sm: 0, md: 0, lg: 0 },
    }} >
      <Dialog open={open} onClose={handlePreviewClose} maxWidth="sm">
        {selectedBank?.qrCodeUrl && (
          <img
            src={selectedBank?.qrCodeUrl}
            alt="QR Code Full"
            style={{
              width: "100%",
              height: "auto",
            }}
          />
        )}
      </Dialog>

      <Box container display={"flex"} mt={0} spacing={2}>
        <Box container mr={3} flex={1}>
          <Grid item xs={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={2.5}>
                <Typography
                  fontWeight="bold"
                  fontSize={"11px"}
                  color={process.env.REACT_APP_COLOR_TEXT || "white"}
                  textAlign={"start"}
                >
                  {t("walletcard.depositpage.paymentMethod")}
                </Typography>
              </Grid>

              <Grid item xs>
                <Tabs onChange={handleTabChange}>
                  {sortedDepositType.map((type, index) => (
                    <Tab
                      key={index}
                      icon={
                        <Image
                          width="75px"
                          height="55px"
                          src={`${process.env.REACT_APP_PROFILE}/payment_method_${index}.png`}
                          sx={{
                            border:
                              index === tabValue
                                ? `2px solid ${theme.palette.primary.main}`
                                : `1px solid ${theme.palette.button.faded.main}`,
                            borderRadius: "5px",
                            background: "rgba(255,255,255,0.25)",
                            py: !mobileView ? 1.5 : 1,
                            px: !mobileView ? 3 : 2,
                            flex: 0,
                          }}
                        />
                      }
                      label={
                        <Typography
                          textTransform="none"
                          textAlign="center"
                          color="primary"
                          fontWeight="bold"
                          fontSize="x-small"
                        >
                          {type.label}
                        </Typography>
                      }
                      sx={{ pl: 0, pt: 0, pb: 0 }}
                    />
                  ))}
                </Tabs>
              </Grid>
            </Grid>
          </Grid>

          {
            selectedCategory === "bank" && (
              <>
                <Grid item xs={12}>
                  <Grid mt={1} container alignItems="center" spacing={2}>
                    <Grid item xs={2.5}>
                      <Typography
                        fontWeight="bold"
                        color={process.env.REACT_APP_COLOR_TEXT || "white"}
                        fontSize={"11px"}
                        textAlign={"start"}
                      >
                        {t("walletcard.depositpage.quickpay.method")}
                      </Typography>
                    </Grid>

                    <Grid item xs>
                      <Grid container spacing={2}>
                        {bankMethodOptions.map((method, index) => (
                          <Grid item xs={"auto"} key={index}>
                            <Box
                              sx={{
                                border: 1,
                                borderRadius: 2,
                                borderColor:
                                  selectedBankMethod === method
                                    ? theme.palette.primary.main
                                    : theme.palette.button.faded.main,
                                display: "flex",
                                height: 50,
                                justifyContent: "center",
                                alignItems: "center",
                                p: 1,
                                backgroundColor: darken(theme.palette.background.paper, 0.1),
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setSelectedBankMethod(method);
                                setSelectedBank(null);
                              }}
                            >
                              {method === "bank" ? (
                                <AccountBalanceIcon sx={{ color: isLightTheme ? "black" : "white", mr: 1 }} />
                              ) : (
                                <QrCodeIcon sx={{ color: isLightTheme ? "black" : "white", mr: 1 }} />
                              )}
                              <Typography color={isLightTheme ? "black" : "white"}>
                                {method === "bank"
                                  ? t("walletcard.depositpage.bankSubTitle")
                                  : t("walletcard.depositpage.qrCode")}
                              </Typography>
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid mt={1} container alignItems="center" spacing={2}>
                    <Grid item xs={2.5}>
                      <Typography
                        fontWeight="bold"
                        fontSize={"11px"}
                        textAlign={"start"}
                        color={process.env.REACT_APP_COLOR_TEXT || "white"}
                      >
                        {t("walletcard.depositpage.title")}
                      </Typography>
                    </Grid>

                    <Grid item xs>
                      <Grid container spacing={2}>
                        {filteredBankDetails?.map((item, index) => (
                          <Grid item key={index} xs={2}>
                            <Box
                              sx={{
                                cursor: "pointer",
                                border: selectedBank?.id === item?.id ? 2 : 0,
                                borderRadius: 1,
                                borderColor:
                                  selectedBank?.id === item?.id
                                    ? theme.palette.primary.main
                                    : "transparent",
                                p: 0.5,
                              }}
                              onClick={() => {
                                TrackFbq("trackCustom", "affiliate_" + item.bankReference);
                                setSelectedBank(item);
                                setAmount(0);
                                setReamount(0);
                              }}
                            >
                              <Image src={item?.thumbnailUrl} />
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Box ref={bankScrollRef} />

                {selectedBank && (
                  <>
                    {selectedBankMethod === "qrCode" && selectedBank?.qrCodeUrl && (
                      <Grid item xs={12}>
                        <Grid container alignItems="center" spacing={2}>
                          <Grid item xs={2.5}>
                            <Typography
                              fontWeight="bold"
                              fontSize={"11px"}
                              textAlign={"start"}
                              color={process.env.REACT_APP_COLOR_TEXT || "white"}
                            >
                              {t("walletcard.depositpage.qrCode")}
                            </Typography>
                          </Grid>

                          <Grid item xs>
                            <Box mt={2}>
                              <img
                                src={selectedBank.qrCodeUrl}
                                alt="QR Code"
                                style={{ width: "150px", height: "150px", display: "block" }}
                                onClick={handlePreviewOpen}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}

                    {selectedBankMethod === "bank" && (
                      <Grid mt={2} item xs={12}>
                        <Grid container alignItems="center" spacing={2}>
                          <Grid item xs={2.5} sx={{}}>
                            <Typography
                              fontWeight="bold"
                              fontSize={"11px"}
                              textAlign={"start"}
                              color={process.env.REACT_APP_COLOR_TEXT || "white"}
                            >
                              {t("walletcard.depositpage.bankingdetails")}
                            </Typography>
                          </Grid>

                          <Grid item xs>
                            <FormControl
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                mt: "5px",
                                "& .MuiTextField-root": {
                                },
                                border: `1px solid ${theme.palette.button.faded.main}`,
                                px: "25px",
                                py: "30px",
                                background: "rgba(255,255,255,0.1)"
                              }}
                            >
                              <TextField
                                sx={{
                                  pb: "30px",
                                  "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: "rgba(128, 128, 128, 0.3) !important",
                                  },
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: process.env.REACT_APP_COLOR_TEXT || "#9e9e9e",
                                  },
                                }}
                                label={t("walletcard.depositpage.bankaccountname")}
                                value={
                                  selectedBank?.bankAccountName ||
                                  bankDetails[0]?.bankAccountName
                                }
                                InputLabelProps={{ shrink: true }}
                                disabled
                                type="text"
                                size="small"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        disableRipple
                                        sx={{
                                          "&.MuiButtonBase-root:hover": {
                                            backgroundColor: "transparent",
                                          },
                                        }}
                                      >
                                        <CopiedTooltip
                                          text={
                                            selectedBank?.bankAccountName ||
                                            bankDetails[0]?.bankAccountName
                                          }
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}

                              />
                              <TextField
                                label={t("walletcard.depositpage.bankaccountnumber")}
                                value={
                                  selectedBank?.bankAccountNumber ||
                                  bankDetails[0]?.bankAccountNumber
                                }
                                sx={{
                                  pb: "30px",
                                  "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: "rgba(128, 128, 128, 0.3) !important",
                                  },
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: process.env.REACT_APP_COLOR_TEXT || "#9e9e9e",
                                  },
                                }}
                                InputLabelProps={{ shrink: true }}
                                disabled
                                type="text"
                                size="small"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        disableRipple
                                        sx={{
                                          "&.MuiButtonBase-root:hover": {
                                            backgroundColor: "transparent",
                                          },
                                        }}
                                      >
                                        <CopiedTooltip
                                          text={
                                            selectedBank?.bankAccountNumber ||
                                            bankDetails[0]?.bankAccountNumber
                                          }
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />

                              {(selectedBank?.bankBSB || bankDetails[0]?.bankBSB) ? (
                                <TextField
                                  sx={{
                                    pb: "30px",
                                    "& .MuiInputBase-root.Mui-disabled": {
                                      backgroundColor: "rgba(128, 128, 128, 0.3) !important",
                                    },
                                    "& .MuiInputBase-input.Mui-disabled": {
                                      WebkitTextFillColor: process.env.REACT_APP_COLOR_TEXT || "#9e9e9e",
                                    },
                                  }}
                                  label={t("walletcard.depositpage.bankbsb")}
                                  value={selectedBank?.bankBSB || bankDetails[0]?.bankBSB}
                                  InputLabelProps={{ shrink: true }}
                                  disabled
                                  type="text"
                                  size="small"
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          disableRipple
                                          sx={{
                                            "&.MuiButtonBase-root:hover": {
                                              backgroundColor: "transparent",
                                            },
                                          }}
                                        >
                                          <CopiedTooltip
                                            text={selectedBank?.bankBSB || bankDetails[0]?.bankBSB}
                                          />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              ) : null}

                              <TextField
                                label={t("walletcard.depositpage.bankreference")}
                                value={
                                  selectedBank?.bankReference ||
                                  bankDetails[0]?.bankReference
                                }
                                InputLabelProps={{ shrink: true }}
                                disabled
                                type="text"
                                size="small"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        disableRipple
                                        sx={{
                                          "&.MuiButtonBase-root:hover": {
                                            backgroundColor: "transparent",
                                          },
                                        }}
                                      >
                                        <CopiedTooltip
                                          text={
                                            selectedBank?.bankReference ||
                                            bankDetails[0]?.bankReference
                                          }
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                                sx={{
                                  "& .MuiInputBase-root.Mui-disabled": {
                                    backgroundColor: "rgba(128, 128, 128, 0.3) !important",
                                  },
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: process.env.REACT_APP_COLOR_TEXT || "#9e9e9e",
                                  },
                                }}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}

                    <Grid mt={2} item xs={12}>
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={2.5}>
                          <Typography
                            fontWeight="bold"
                            fontSize={"11px"}
                            textAlign={"start"}
                            color={process.env.REACT_APP_COLOR_TEXT || "white"}
                          >
                            {t("walletcard.depositpage.depositdetails")}
                          </Typography>
                        </Grid>

                        <Grid item xs sx={{}}>
                          <Box sx={{
                            border: `1px solid ${theme.palette.button.faded.main}`,
                            px: "25px",
                            py: "30px",
                            background: "rgba(255,255,255,0.1)"
                          }}>
                            <form onSubmit={handleSubmit(submitDeposit)}>
                              <Grid item container justifyContent="space-between" spacing={1}>
                                <Grid item>
                                  <Typography variant="subtitle1" fontWeight={"bold"} color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="small">
                                    {t("Deposit Quota")}
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Typography variant="subtitle1" color="#FDB813" fontSize="12px">
                                    {t(`${process.env.REACT_APP_CURRENCY_CODE} ${minDeposit} - ${process.env.REACT_APP_CURRENCY_CODE} ${maxDeposit}`)}
                                  </Typography>
                                </Grid>
                              </Grid>

                              <FormTextField
                                label={`${t("walletcard.depositpage.amount")} (${process.env.REACT_APP_CURRENCY_CODE})`}
                                control={control}
                                controllerName="amount"
                                defaultValue={""}
                                placeholder={withLiveMin("placeholder.minamount")}
                                size="small"
                                onChange={handleAmountChange}
                                style={{
                                  marginTop: 1,
                                  display: "block",
                                }}
                              />

                              <Grid my={2} container wrap="nowrap" display={"flex"} spacing={!mobileView ? 1 : undefined} justifyContent={mobileView ? "space-between" : undefined}>
                                {depositDetails?.defaultAmountSelection?.map((item, index) => (
                                  <Grid item key={index}>
                                    <Button
                                      key={index}
                                      disableRipple
                                      sx={{
                                        "&.MuiButtonBase-root:hover": {
                                          backgroundColor: "transparent",
                                        },
                                      }}
                                      onClick={() => {
                                        TrackFbq("trackCustom", "clickDeposit_" + item.content);
                                        setValue("amount", item.content, { shouldValidate: true });

                                        const processingFee =
                                          selectedBank?.processingFee || bankDetails[0]?.processingFee || 0;
                                        const reamountValue =
                                          parseFloat(item.content) + parseFloat(processingFee);
                                        setReamount(isNaN(reamountValue) ? "" : reamountValue.toFixed(2));
                                      }}
                                    >
                                      <Box
                                        display="flex"
                                        flex={1}
                                        sx={{
                                          border: 1,
                                          borderColor: process.env.REACT_APP_COLOR_TEXT || "white",
                                          boxShadow: 3,
                                          borderRadius: "5px",
                                          cursor: "pointer",
                                        }}
                                        justifyContent="center"
                                        alignItems="center"
                                      >
                                        <Typography
                                          sx={{
                                            color: process.env.REACT_APP_COLOR_TEXT || "white",
                                            fontSize: "12px",
                                            paddingY: 1,
                                            paddingX: 0.6
                                          }}
                                        >
                                          {item.content}
                                        </Typography>
                                      </Box>
                                    </Button>
                                  </Grid>
                                ))}
                              </Grid>

                              <FormFileInput
                                label={t("walletcard.depositpage.receipt")}
                                control={control}
                                controllerName="receipt"
                                defaultValue={""}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                type="file"
                                margin="dense"
                                size="small"
                              />
                            </form>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid mb={2} mt={2} item xs={12}>
                      <Grid container >
                        <Grid item xs={2.5} />
                        <Grid item xs={"auto"}>
                          <Box alignSelf="center" >
                            <Button
                              color="success"
                              variant="contained"
                              type="submit"
                              disabled={isCooldown || eWalletSubmit}
                              onClick={() => {
                                handleSubmitClick();
                                handleSubmit(submitDeposit)();
                              }}
                              startIcon={isCooldown && <CircularProgress size={20} />}
                              sx={{
                                width: mobileView ? "100%" : undefined,
                                backgroundColor: isCooldown ? "red" : "success.main",
                                "&:hover": {
                                  backgroundColor: isCooldown ? "red" : "success.dark",
                                },
                                "&.Mui-disabled": {
                                  backgroundColor: "red",
                                  color: "white",
                                },
                              }}
                            >
                              {isCooldown ? `Deposit (${timer}s)` : 'Deposit'}
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>                  </>
                )}
              </>
            )
          }

          {
            selectedCategory === "paymentgateway" && (
              <>
                <Grid mt={1} item xs={12}>
                  <Grid mt={1} container alignItems="center" spacing={2}>
                    <Grid item xs={2.5}>
                      <Typography mt={1} mb={1} fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
                        fontSize: "11px"
                      }}>
                        {t("walletcard.depositpage.quickpay.method")}
                      </Typography>
                    </Grid>

                    <Grid item xs>
                      <Grid container spacing={2}>
                        {depositDetails?.paymentGateways && Object.keys(depositDetails?.paymentGateways)?.map((method) => (
                          <Grid item xs={6} sm={3}>
                            <Box
                              sx={{
                                border: 2.5,
                                borderRadius: 2,
                                borderColor:
                                  selectedQuickpay ===
                                    depositDetails?.paymentGateways[method]?.paymentGateway
                                    ? theme.palette.primary.main
                                    : theme.palette.button.faded.main,
                                display: "flex",
                                height: 50,
                                alignItems: "center",
                                justifyContent: "center",
                                p: 1,
                                backgroundColor: darken(
                                  theme.palette.background.paper,
                                  0.1
                                ),
                                cursor: "pointer"
                              }}
                              onClick={() => {
                                setSelectedQuickpay(
                                  depositDetails?.paymentGateways[method]?.paymentGateway
                                );
                                setAllQuickpayBank(
                                  depositDetails?.paymentGateways[method]?.banks
                                );
                                setSelectedQuickpayBank(
                                  depositDetails?.paymentGateways[method]?.banks[0]
                                );
                                setSelectedQuickpayBankCategory("BANK");
                              }}
                            >
                              <Image
                                width="40px"
                                height="40px"
                                src={
                                  depositDetails?.paymentGateways[method]
                                    ?.paymentGatewayIcon
                                }
                              />
                            </Box>
                            <Typography color={process.env.REACT_APP_COLOR_TEXT || "white"} textAlign={"center"} fontSize={"12px"}>
                              {depositDetails?.paymentGateways[method]?.paymentGateway === "LNWPAY" ? "ESEWA" :
                                depositDetails?.paymentGateways[method]?.paymentGateway === "LNWPAYHK" ? "LNWPAY" :
                                  depositDetails?.paymentGateways[method]?.name || depositDetails?.paymentGateways[method]?.paymentGateway
                              }
                            </Typography>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>

                  {isKR && selectedQuickpay === 'SULIFU' ? (
                    <Grid mt={1} container alignItems="center" spacing={2}>
                      <Grid item xs={2.5}>
                        <Typography fontSize="11px"
                          fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} mb={1}>
                          {t("walletcard.depositpage.quickpay.bank")}
                        </Typography>
                      </Grid>

                      <Grid item xs>
                        <Grid mt={1} container spacing={2}>
                          <Box display="flex" alignItems="center" gap={1} mt={1}>
                            {isUserBankAccountsLoading ? (
                              <CircularProgress size={24} />
                            ) : userBankAccounts?.result?.data?.length > 0 ? (

                              <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel sx={{ color: process.env.REACT_APP_COLOR_TEXT || "white" }}>
                                  {t("walletcard.bankaccountpage.bankaccount")}
                                </InputLabel>
                                <Select
                                  value={selectedUserBankId || ""}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setSelectedUserBankId(value);
                                  }}
                                  label={t("walletcard.bankaccountpage.bankaccount")}
                                  renderValue={(selectedKey) => {
                                    const selectedBank = userBankAccounts?.result?.data?.find(
                                      (bank) => `${bank.bankCode}-${bank.bankAccountNumber}` === selectedKey
                                    );
                                    return selectedBank ? (
                                      <Box display="flex" flexDirection="column">
                                        <Typography variant="body2" fontWeight="bold">
                                          {bankConfigMap?.[selectedBank.bankCode] || selectedBank.bankCode}
                                        </Typography>
                                        <Typography variant="caption" sx={{ opacity: 0.8 }}>
                                          {selectedBank.bankAccountNumber}
                                        </Typography>
                                      </Box>
                                    ) : (
                                      ""
                                    );
                                  }}
                                  sx={{
                                    color: "white",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: theme.palette.button.faded.main,
                                    },
                                    "& .MuiSvgIcon-root": {
                                      color: "white",
                                    },
                                  }}
                                >
                                  {userBankAccounts?.result?.data?.map((bank) => {
                                    const key = `${bank.bankCode}-${bank.bankAccountNumber}`;
                                    return (
                                      <MenuItem key={key} value={key}>
                                        <Box display="flex" flexDirection="column">
                                          <Typography variant="body2" fontWeight="bold">
                                            {bankConfigMap?.[bank.bankCode] || bank.bankCode}
                                          </Typography>
                                          <Tooltip title={bank.bankAccountNumber}>
                                            <Typography variant="caption" sx={{ opacity: 0.8 }}>
                                              {bank.bankAccountNumber}
                                            </Typography>
                                          </Tooltip>
                                        </Box>
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </FormControl>

                            ) : (
                              <Typography color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{ flexGrow: 1 }}>
                                {t("walletcard.bankaccountpage.no_bank_account")}
                              </Typography>
                            )}
                            <Button
                              variant="contained"
                              onClick={() =>
                                navigate(Constant.getPath("/profileWallet"), {
                                  state: { screen: "bank account" },
                                })}
                              sx={{ whiteSpace: 'nowrap', height: '56px' }}
                            >
                              <AddIcon sx={{ fontSize: 30 }} />
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) :
                    (
                      <>
                        {selectedQuickpay && (
                          <Grid mt={1} container alignItems="center" spacing={2}>
                            <Grid item xs={2.5}>
                              <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="11px">
                                {t("walletcard.depositpage.quickpay.bank")}
                              </Typography>
                            </Grid>

                            <Grid item xs>
                              {isGrouped ? (
                                <>
                                  {/* ── Category Selector ── */}
                                  <Grid container spacing={2} mb={2}>
                                    {Object.keys(groupedQuickpayBank).map((category) => (
                                      <Grid item xs={"auto"} key={category}>
                                        <Box
                                          sx={{
                                            border: 1,
                                            borderRadius: 2,
                                            borderColor:
                                              selectedQuickpayBankCategory === category
                                                ? theme.palette.primary.main
                                                : theme.palette.button.faded.main,
                                            display: "flex",
                                            height: 50,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            px: 3,
                                            backgroundColor: darken(theme.palette.background.paper, 0.1),
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setSelectedQuickpayBankCategory(category);
                                            setSelectedQuickpayBank(null);
                                            setAmount(0);
                                            setReamount(0);
                                          }}
                                        >
                                          {category === "BANK"
                                            ? <AccountBalanceIcon sx={{ color: isLightTheme ? "black" : "white", mr: 1 }} />
                                            : <WalletIcon sx={{ color: isLightTheme ? "black" : "white", mr: 1 }} />
                                          }
                                          <Typography color={isLightTheme ? "black" : "white"} fontSize="13px" fontWeight="bold">
                                            {category === "BANK"
                                              ? t("walletcard.depositpage.bankSubTitle")
                                              : t("walletcard.depositpage.ewallet")}
                                          </Typography>
                                        </Box>
                                      </Grid>
                                    ))}
                                  </Grid>

                                  {/* ── Filtered bank list by selected category ── */}
                                  <Grid container spacing={1}>
                                    {(groupedQuickpayBank[selectedQuickpayBankCategory] || []).map((quickpayBank) => (
                                      <Grid item xs={6} sm={3} key={quickpayBank?.bankCode}>
                                        <Box
                                          sx={{
                                            border: 1,
                                            borderRadius: 2,
                                            borderColor:
                                              selectedQuickpayBank?.bankCode === quickpayBank?.bankCode
                                                ? theme.palette.primary.main
                                                : darken(theme.palette.background.paper, 0.2),
                                            display: "flex",
                                            height: 50,
                                            justifyContent: "center",
                                            alignItems: "center",
                                            p: 1,
                                            backgroundColor: darken(theme.palette.background.paper, 0.1),
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setSelectedQuickpayBank(quickpayBank);
                                            setAmount(0);
                                            setReamount(0);
                                          }}
                                        >
                                          <Image width="40px" height="40px" src={quickpayBank?.iconUrl} />
                                        </Box>
                                        <Typography fontSize={"12px"} textAlign={"center"}
                                          color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                                          {quickpayBank?.bankName}
                                        </Typography>
                                      </Grid>
                                    ))}
                                  </Grid>
                                </>
                              ) : (
                                // ── Flat array — no category, display as default ──
                                <Grid container spacing={1}>
                                  {(allQuickpayBank || []).map((quickpayBank) => (
                                    <Grid item xs={6} sm={3} key={quickpayBank?.bankCode}>
                                      <Box
                                        sx={{
                                          border: 1,
                                          borderRadius: 2,
                                          borderColor:
                                            selectedQuickpayBank?.bankCode === quickpayBank?.bankCode
                                              ? theme.palette.primary.main
                                              : darken(theme.palette.background.paper, 0.2),
                                          display: "flex",
                                          height: 50,
                                          justifyContent: "center",
                                          alignItems: "center",
                                          p: 1,
                                          backgroundColor: darken(theme.palette.background.paper, 0.1),
                                          cursor: "pointer",
                                        }}
                                        onClick={() => {
                                          setSelectedQuickpayBank(quickpayBank);
                                          setAmount(0);
                                          setReamount(0);
                                        }}
                                      >
                                        <Image width="40px" height="40px" src={quickpayBank?.iconUrl} />
                                      </Box>
                                      <Typography fontSize={"12px"} textAlign={"center"}
                                        color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                                        {quickpayBank?.bankName}
                                      </Typography>
                                    </Grid>
                                  ))}
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        )}
                      </>
                    )
                  }
                  {
                    selectedQuickpayBank && (
                      <Grid mt={1} container alignItems="center" spacing={2}>
                        <Grid item xs={2.5}>
                          <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} sx={{
                            fontSize: "11px"
                          }}>
                            {t("walletcard.depositpage.quickpay.depositamount")}
                          </Typography>
                        </Grid>

                        <Grid item xs>
                          <Grid>
                            <Grid item container justifyContent="space-between">
                              <Grid item>
                                <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="11px">{t("Deposit Quota")}</Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="subtitle1" color="#FDB813" fontSize="11px">{t(`${process.env.REACT_APP_CURRENCY_CODE} ${minDeposit} - ${process.env.REACT_APP_CURRENCY_CODE} ${maxDeposit}`)}</Typography>
                              </Grid>
                            </Grid>

                            <form onSubmit={handleQpSubmit(submitQuickpay)}>
                              <FormTextField
                                label={`${t("walletcard.depositpage.quickpay.amount")} (${process.env.REACT_APP_CURRENCY_CODE
                                  })`}
                                control={qpControl}
                                controllerName="amount"
                                defaultValue={""}
                                placeholder={withLiveMin("placeholder.minamount")}
                                size="small"
                                onChange={handleAmountChange}
                                style={{
                                  marginTop: .5,
                                  display: "block",
                                }}
                              />

                              {depositDetails?.paymentGateways[selectedQuickpay]?.isCrypto && (
                                <Grid container spacing={1} alignItems="center">
                                  <Grid item>
                                    <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">
                                      {t("walletcard.depositpage.cryptoamount")} :
                                    </Typography>
                                  </Grid>
                                  <Grid item>
                                    <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                                      {cryptoAmount}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              )}

                              <Grid wrap="nowrap" ml={0} container py={2}>
                                {depositDetails?.defaultAmountSelection?.map((item, index) => (
                                  <Grid ml={0} item>
                                    <Button
                                      key={index}
                                      disableRipple
                                      sx={{
                                        "&.MuiButtonBase-root:hover": {
                                          backgroundColor: "transparent",
                                        },
                                      }}
                                      onClick={() => {
                                        TrackFbq('trackCustom', 'clickDeposit_' + item.content);

                                        setQpValue("amount", item.content, {
                                          shouldValidate: true,
                                        });
                                        setAmount(item.content);
                                        // Update reamount when clicking on the button
                                        const processingFee = selectedQuickpayBank?.processingFee || 0;
                                        const reamountValue = parseFloat(item.content) + parseFloat(processingFee);
                                        setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));
                                      }}
                                    >
                                      <Box display="flex"
                                        flex={1}
                                        sx={{
                                          border: 1,
                                          borderColor: process.env.REACT_APP_COLOR_TEXT || 'white',
                                          boxShadow: 3,
                                          borderRadius: "5px",
                                        }}
                                        justifyContent="center"
                                        alignItems="center"
                                      >
                                        <Typography
                                          sx={{
                                            color: process.env.REACT_APP_COLOR_TEXT || 'white',
                                            fontSize: "12px",
                                            paddingY: 1,
                                            paddingX: 0.6,
                                          }}
                                        >
                                          {item.content}
                                        </Typography>
                                      </Box>
                                    </Button>
                                  </Grid>
                                ))}
                              </Grid>
                              <Box display="flex">
                                <Button disabled={gatewaySubmit} color="success" variant="contained" type="submit">
                                  {t("walletcard.depositpage.quickpay.deposit")}
                                </Button>
                              </Box>
                            </form>

                          </Grid>
                        </Grid>
                      </Grid>
                    )
                  }
                </Grid>
              </>
            )
          }

          {
            selectedCategory === "ewallet" && (
              <Grid mt={1} item xs={12}>

                <Grid mt={1} container alignItems="center" spacing={2}>
                  <Grid item xs={2.5}>
                    <Typography fontSize={"11px"} fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} mb={2}>
                      {t("walletcard.depositpage.quickpay.method")}
                    </Typography>
                  </Grid>

                  <Grid item xs>
                    <Grid container spacing={2}>
                      {["bank", "qrCode"].map((method, index) => (
                        <Grid item xs={3} key={index}>
                          <Box
                            sx={{
                              border: 1,
                              borderRadius: 2,
                              borderColor:
                                selectedQrCodeMethod === method
                                  ? theme.palette.primary.main
                                  : theme.palette.button.faded.main,
                              display: "flex",
                              height: 50,
                              justifyContent: "center",
                              alignItems: "center",
                              p: 1,

                              backgroundColor: darken(theme.palette.background.paper, 0.1),
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedQrCodeMethod(method);
                            }}
                          >
                            {method === "bank" ? (
                              <AccountBalanceIcon sx={{ color: isLightTheme ? "black" : "white", mr: 1 }} />
                            ) : (
                              <QrCodeIcon sx={{ color: isLightTheme ? "black" : "white", mr: 1 }} />
                            )}
                            <Typography color={isLightTheme ? "black" : process.env.REACT_APP_COLOR_TEXT || "white"}>
                              {method === "bank"
                                ? t("walletcard.depositpage.bankSubTitle")
                                : t("walletcard.depositpage.qrCode")}
                            </Typography>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>

                  </Grid>
                </Grid>

                <Grid mt={1} container alignItems="center" spacing={2}>
                  <Grid item xs={2.5}>
                    <Typography fontSize={"11px"} fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                      {t("walletcard.depositpage.bankSubTitle")}
                    </Typography>
                  </Grid>

                  <Grid item xs>
                    <Grid container spacing={2}>
                      {eWalletDetails?.map((item, index) => (
                        <Grid item key={index} xs={4} sm={2}>
                          <Box
                            sx={{
                              cursor: "pointer",
                              border: selectedEwalletBank?.id === item?.id ? 2 : null,
                              borderRadius: 1,
                              borderColor:
                                selectedEwalletBank?.id === item?.id
                                  ? theme.palette.primary.main
                                  : null,
                            }}
                            onClick={() => {
                              setSelectedEwalletBank(item);
                              setAmount(0);
                              setReamount(0);
                              setSelectedQrCodeMethod('bank');
                              /*    const processingFee = (selectedBank?.processingFee || bankDetails[0]?.processingFee) || 0;
                                  const reamountValue = parseFloat(processingFee);
                                  setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));*/
                            }}
                          >
                            <Image src={item?.thumbnailUrl} />
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>

                {selectedQrCodeMethod === "qrCode" && selectedEwalletBank?.qrCodeUrl && (
                  <Grid mt={1} container alignItems="center" spacing={2}>
                    <Grid item xs={2.5}>
                      <Typography fontSize={"11px"} fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {t("walletcard.depositpage.qrCode")}
                      </Typography>
                    </Grid>

                    <Grid item xs>
                      <img
                        src={selectedEwalletBank.qrCodeUrl}
                        alt="QR Code"
                        style={{ width: "150px", height: "150px", display: "block" }}
                      />
                    </Grid>
                  </Grid>
                )}

                {selectedQrCodeMethod === "bank" && (
                  <Grid mt={1} container alignItems="center" spacing={2}>
                    <Grid item xs={2.5}>
                      <Typography fontSize={"11px"} fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"}>
                        {t("walletcard.depositpage.bankingdetails")}
                      </Typography>
                    </Grid>

                    <Grid item xs>
                      <FormControl
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          mt: "5px",
                          "& .MuiTextField-root": {
                            pb: "30px",
                          },
                          border: `1px solid ${theme.palette.button.faded.main}`,
                          pt: "25px",
                          pl: "18px",
                          pr: "18px",
                          mb: "5px",
                          background: "rgba(255,255,255,0.1)"
                        }}
                      >
                        <TextField
                          label={t("walletcard.depositpage.bankaccountname")}
                          value={
                            selectedEwalletBank?.bankAccountName ||
                            eWalletDetails[0]?.bankAccountName
                          }
                          InputLabelProps={{ shrink: true }}
                          disabled
                          type="text"
                          size="small"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  disableRipple
                                  sx={{
                                    "&.MuiButtonBase-root:hover": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                                >
                                  <CopiedTooltip
                                    text={
                                      selectedEwalletBank?.bankAccountName ||
                                      eWalletDetails[0]?.bankAccountName
                                    }
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            "& .MuiInputBase-root.Mui-disabled": {
                              backgroundColor: "rgba(128, 128, 128, 0.3) !important",
                            },
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: process.env.REACT_APP_COLOR_TEXT || "#9e9e9e",
                            },
                          }}
                        />
                        <TextField
                          label={t("walletcard.depositpage.bankaccountnumber")}
                          value={
                            selectedEwalletBank?.bankAccountNumber ||
                            eWalletDetails[0]?.bankAccountNumber
                          }
                          InputLabelProps={{ shrink: true }}
                          disabled
                          type="text"
                          size="small"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  disableRipple
                                  sx={{
                                    "&.MuiButtonBase-root:hover": {
                                      backgroundColor: "transparent",
                                    },
                                  }}

                                >
                                  <CopiedTooltip
                                    text={
                                      selectedEwalletBank?.bankAccountNumber ||
                                      eWalletDetails[0]?.bankAccountNumber
                                    }
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            "& .MuiInputBase-root.Mui-disabled": {
                              backgroundColor: "rgba(128, 128, 128, 0.3) !important",
                            },
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: process.env.REACT_APP_COLOR_TEXT || "#9e9e9e",
                            },
                          }}
                        />

                        {(selectedEwalletBank?.bankBSB || eWalletDetails[0]?.bankBSB) ? (
                          <TextField
                            label={t("walletcard.depositpage.bankbsb")}
                            value={selectedEwalletBank?.bankBSB || eWalletDetails[0]?.bankBSB}
                            InputLabelProps={{ shrink: true }}
                            disabled
                            type="text"
                            size="small"
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    disableRipple
                                    sx={{
                                      "&.MuiButtonBase-root:hover": {
                                        backgroundColor: "transparent",
                                      },
                                    }}
                                  >
                                    <CopiedTooltip
                                      text={selectedEwalletBank?.bankBSB || eWalletDetails[0]?.bankBSB}
                                    />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              "& .MuiInputBase-root.Mui-disabled": {
                                backgroundColor: "rgba(128, 128, 128, 0.3) !important",
                              },
                              "& .MuiInputBase-input.Mui-disabled": {
                                WebkitTextFillColor: process.env.REACT_APP_COLOR_TEXT || "#9e9e9e",
                              },
                            }}
                          />
                        ) : null}

                        <TextField
                          label={t("walletcard.depositpage.bankreference")}
                          value={
                            selectedEwalletBank?.bankReference ||
                            eWalletDetails[0]?.bankReference
                          }
                          InputLabelProps={{ shrink: true }}
                          disabled
                          type="text"
                          size="small"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  disableRipple
                                  sx={{
                                    "&.MuiButtonBase-root:hover": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                                >
                                  <CopiedTooltip
                                    text={
                                      selectedEwalletBank?.bankReference ||
                                      eWalletDetails[0]?.bankReference
                                    }
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            "& .MuiInputBase-root.Mui-disabled": {
                              backgroundColor: "rgba(128, 128, 128, 0.3) !important",
                            },
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: process.env.REACT_APP_COLOR_TEXT || "#9e9e9e",
                            },
                          }}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                )}

                <Grid mt={1} container alignItems="center" spacing={2}>
                  <Grid item xs={2.5}>
                    <Typography fontSize={"11px"} fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} mb="5px">
                      {t("walletcard.depositpage.depositdetails")}
                    </Typography>
                  </Grid>

                  <Grid item xs>
                    <Box sx={{
                      border: `1px solid ${theme.palette.button.faded.main}`,
                      pt: "10px",
                      pb: "10px",
                      pl: "18px",
                      pr: "18px",
                      background: "rgba(255,255,255,0.1)"
                    }}>
                      <form onSubmit={handleSubmit(submitDeposit)}>
                        <Grid item container justifyContent="space-between" spacing={1}>
                          <Grid item>
                            <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="14px">
                              {t("Deposit Quota")}
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography variant="subtitle1" color="#FDB813" fontSize="12px">
                              {t(`${process.env.REACT_APP_CURRENCY_CODE} ${minDeposit} - ${process.env.REACT_APP_CURRENCY_CODE} ${maxDeposit}`)}
                            </Typography>
                          </Grid>
                        </Grid>

                        <FormTextField
                          label={`${t("walletcard.depositpage.amount")} (${process.env.REACT_APP_CURRENCY_CODE})`}
                          control={control}
                          controllerName="amount"
                          defaultValue={""}
                          placeholder={withLiveMin("placeholder.minamount")}
                          size="small"
                          onChange={handleAmountChange}
                        />

                        <Grid container spacing={1} alignItems="center">
                          <Grid item>
                            <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">
                              {t("walletcard.depositpage.processingfee")} :
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                              {process.env.REACT_APP_CURRENCY_CODE} {selectedEwalletBank?.processingFee || eWalletDetails[0]?.processingFee || '0.00'}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={1} alignItems="center">
                          <Grid item>
                            <Typography variant="subtitle1" color={process.env.REACT_APP_COLOR_TEXT || "white"} fontSize="12px">
                              {t("walletcard.depositpage.receivableamount")} :
                            </Typography>
                          </Grid>
                          <Grid item>
                            {errorMessage ? (
                              <Typography fontWeight="bold" color="error" align="right" fontSize="12px">
                                {errorMessage}
                              </Typography>
                            ) : (
                              <Typography fontWeight="bold" color={process.env.REACT_APP_COLOR_TEXT || "white"} align="right" fontSize="12px">
                                {process.env.REACT_APP_CURRENCY_CODE} {reamount || '0.00'}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>

                        <Grid wrap="nowrap" container my={3}>
                          {depositDetails?.defaultAmountSelection?.map((item, index) => (
                            <Grid item key={index}>
                              <Button
                                disableRipple
                                sx={{
                                  "&.MuiButtonBase-root:hover": {
                                    backgroundColor: "transparent",
                                  },
                                }}
                                onClick={() => {
                                  TrackFbq('trackCustom', 'clickDeposit_' + item.content);
                                  setValue("amount", item.content, { shouldValidate: true });
                                  const processingFee = (selectedEwalletBank?.processingFee || eWalletDetails[0]?.processingFee) || 0;
                                  const reamountValue = parseFloat(item.content) + parseFloat(processingFee);
                                  setReamount(isNaN(reamountValue) ? '' : reamountValue.toFixed(2));
                                }}
                              >
                                <Box display="flex"
                                  flex={1}
                                  sx={{
                                    border: 1,
                                    borderColor: process.env.REACT_APP_COLOR_TEXT || 'white',
                                    boxShadow: 3,
                                    borderRadius: "5px",
                                  }}
                                  justifyContent="center"
                                  alignItems="center"
                                >
                                  <Typography
                                    sx={{
                                      color: process.env.REACT_APP_COLOR_TEXT || 'white',
                                      fontSize: "12px",
                                      paddingY: 1,
                                      paddingX: 0.6,
                                    }}
                                  >
                                    {item.content}
                                  </Typography>
                                </Box>
                              </Button>
                            </Grid>
                          ))}
                        </Grid>

                        <FormFileInput
                          label={t("walletcard.depositpage.attachment")}
                          control={control}
                          controllerName="receipt"
                          defaultValue={""}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          type="file"
                          margin="dense"
                          size="small"
                        />
                      </form>
                    </Box>
                  </Grid>
                </Grid>

                <Grid mt={1} container alignItems="center" spacing={2}>
                  <Grid item xs={2.5} />
                  <Grid item xs>
                    <Box alignSelf="center" mb={3}>
                      <Button
                        color="success"
                        variant="contained"
                        disabled={isCooldown || eWalletSubmit}
                        onClick={() => {
                          handleSubmitClick();
                          handleSubmit(submitDeposit)();
                        }}
                        startIcon={(isCooldown || eWalletSubmit) && <CircularProgress size={20} />}
                        sx={{
                          width: mobileView ? "100%" : undefined,
                          backgroundColor: isCooldown ? "red" : "success.main",
                          "&:hover": {
                            backgroundColor: isCooldown ? "red" : "success.dark",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "red",
                            color: "white",
                          },
                        }}
                      >
                        {isCooldown ? `Deposit (${timer}s)` : 'Deposit'}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            )
          }
        </Box>
        {
          depositDesc && depositDesc?.result && (
            <Box sx={{
              width: "35%",
              display: "block",
            }}>
              <Box sx={{
                py: 1,
                px: 2.5,
                border: 1,
                borderColor: process.env.REACT_APP_COLOR_TEXT || "white",
                borderRadius: 2,
                boxShadow: 15,
              }}>
                <Typography
                  dangerouslySetInnerHTML={{ __html: depositDesc?.result }}
                />
              </Box>
            </Box>
          )
        }
      </Box >
    </Container >
  );
};

export default Deposit2;